import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import { Minimatch } from 'minimatch';

/**
 * @class Fb
 */
var Fb = /*#__PURE__*/function () {
  function Fb(options) {
    _classCallCheck(this, Fb);
    this.eventsQueue = [];
    this.fqbLoaded = false;
    this.options = options;
    this.fbq = null;
    this.isEnabled = !options.disabled;
  }
  return _createClass(Fb, [{
    key: "setFbq",
    value: function setFbq(fbq) {
      this.fbq = fbq;
      this.fqbLoaded = true;
      this.send();
    }
  }, {
    key: "setPixelId",
    value: function setPixelId(pixelId) {
      this.options.pixelId = pixelId;
      this.init();
    }

    /**
     * @method setUserData
     * Used to set user data that'll be used once the `fbq` init function is called.
     * @param {object} [userData] See https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching#reference
     */
  }, {
    key: "setUserData",
    value: function setUserData(userData) {
      this.userData = userData;
    }

    /**
     * @method enable
     */
  }, {
    key: "enable",
    value: function enable() {
      this.isEnabled = true;
      this.init();
      this.track();
    }

    /**
     * @method disable
     */
  }, {
    key: "disable",
    value: function disable() {
      this.isEnabled = false;
    }

    /**
     * @method init
     */
  }, {
    key: "init",
    value: function init() {
      this.query('init', this.options.pixelId, this.userData || undefined);
    }

    /**
     * @method track
     */
  }, {
    key: "track",
    value: function track() {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var eventID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      if (!event) {
        event = this.options.track;
      }
      if (!eventID) {
        this.query('track', event, parameters);
      } else {
        this.query('track', event, parameters, eventID);
      }
    }

    /**
     * @method query
     * @param {string} cmd
     * @param {object} option
     * @param {object} parameters
     * @param {object} eventID
     */
  }, {
    key: "query",
    value: function query(cmd, option) {
      var parameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var eventID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      if (this.options.debug) log('Command:', cmd, 'Option:', option, 'Additional parameters:', parameters, "EventID:", eventID);
      if (!this.isEnabled) return;
      this.eventsQueue.push({
        cmd: cmd,
        option: option,
        parameters: parameters,
        eventID: eventID
      });
      this.send();
    }
  }, {
    key: "send",
    value: function send() {
      if (!this.fqbLoaded) {
        return;
      }
      while (this.eventsQueue.length) {
        var event = this.eventsQueue.shift();
        if (this.options.debug) log('Send event: ', event);
        if (event.eventID) {
          this.fbq(event.cmd, event.option, event.parameters, event.eventID);
        } else if (event.parameters) {
          this.fbq(event.cmd, event.option, event.parameters);
        } else {
          this.fbq(event.cmd, event.option);
        }
      }
    }
  }]);
}();
function getMatchingPixel(options, path) {
  return options.pixels.find(function (pixel) {
    var routeIndex = pixel.routes.findIndex(function (route) {
      var minimatch = new Minimatch(route);
      return minimatch.match(path);
    });
    return routeIndex !== -1;
  });
}
function log() {
  for (var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++) {
    messages[_key] = arguments[_key];
  }
  console.info.apply(this, ['[nuxt-facebook-pixel-module]'].concat(messages));
}
export default (function (ctx, inject) {
  var parsedOptions = {
    "pixelId": "2722839061196394",
    "track": "PageView",
    "autoPageView": false,
    "version": "2.0",
    "pixels": [],
    "manualMode": false,
    "disabled": true,
    "debug": false,
    "dev": false
  };
  var isDev = parsedOptions.dev && !parsedOptions.debug;
  if (isDev) log('You are running in development mode. Set "debug: true" in your nuxt.config.js if you would like to trigger tracking events in local.');
  var path = ctx.route.path;
  var matchingPixel = getMatchingPixel(parsedOptions, path);
  var pixelOptions = Object.assign({}, matchingPixel || parsedOptions);
  var instance = new Fb(pixelOptions);

  /* eslint-disable */
  if (typeof window !== 'undefined') {
    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = pixelOptions.version;
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.defer = true;
      t.src = v;
      s = b.getElementsByTagName('body')[0];
      s.parentNode.appendChild(t, s);
      var onLoadCallback = function onLoadCallback() {
        instance.setFbq(fbq);
        if (!isDev && !pixelOptions.disabled) {
          if (pixelOptions.manualMode) {
            fbq('set', 'autoConfig', false, pixelOptions.pixelId);
          }
          fbq('init', pixelOptions.pixelId);
          fbq('track', pixelOptions.track);
        }
      };
      if (t.readyState) {
        t.onreadystatechange = function () {
          if (t.readyState === "loaded" || t.readyState === "complete") {
            t.onreadystatechange = null;
            onLoadCallback();
          }
        };
      } else {
        t.onload = onLoadCallback;
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  }
  /* eslint-enable */

  if (ctx.app && ctx.app.router) {
    var router = ctx.app.router;
    router.afterEach(function (_ref) {
      var path = _ref.path;
      /**
       * Change the current pixelId according to the route.
       */
      var matchingPixel = getMatchingPixel(parsedOptions, path);
      var pixelOptions = Object.assign({}, matchingPixel || parsedOptions);
      if (pixelOptions.pixelId !== instance.options.pixelId) {
        instance.setPixelId(pixelOptions.pixelId);
      }

      /**
       * Automatically track PageView
       */
      if (parsedOptions.autoPageView) {
        instance.track('PageView');
      }
    });
  }

  /* eslint-enable */
  ctx.$fb = instance;
  inject('fb', instance);
});